/** @jsx jsx */
import { jsx } from '@emotion/react';

type Props = {
  className?: string;
  width?: number;
  height?: number;
};

const MicrosoftLogoSvg = ({ className, width = 66, height = 72 }: Props) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 66 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M0 0H31.362V34.2135H0V0Z" fill="#F25022" />
    <path d="M34.638 0H66V34.2135H34.638V0Z" fill="#7FBA00" />
    <path d="M0 37.7866H31.362V72H0V37.7866Z" fill="#00A4EF" />
    <path d="M34.638 37.7866H66V72H34.638V37.7866Z" fill="#FFB900" />
  </svg>
);

export default MicrosoftLogoSvg;
